'use strict';

const storage = require('./storage-helper');

const { getOfferRedemptionData } = require('./redemption-helper');

function handleSuccessResponse(outlink, response, routes, referralSource) {
  const data = getOfferRedemptionData(response);

  storage.setItem('@redemption', data);

  if (outlink) {
    let route = routes.outlink.main.replace('{offerId}', data.offerId);

    if (referralSource) {
      route += `?referralSource=${referralSource}`;
    }

    outlink.location.replace(route);
  }

  return data;
}

function handleFailResponse(outlink, error) {
  if (outlink) {
    outlink.close();
  }

  return {
    type: 'ALERT',
    errorCode: error,
    alertMessage: 'GeneralError',
  };
}

function redemptionHandler({
  offerId,
  routes,
  referralSource,
  openOutlink = true,
  action = 'main',
}) {
  const outlink = openOutlink ? window.open('about:blank', '_blank') : null;
  const endpoint = routes.redemption[action].replace('{offerId}', offerId);

  return window
    .fetch(endpoint)
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.status);
      }

      return response.json().then(data => {
        return handleSuccessResponse(outlink, data, routes, referralSource);
      });
    })
    .catch(error => handleFailResponse(outlink, error && error.message));
}

module.exports = redemptionHandler;
